/**
 * Fruit Game — single tuning knob.
 *
 * Spec: docs/superpowers/specs/2026-05-27-fruit-merge-2d-gameplay-design.md
 */

export const FRUIT_TIERS = [
  { name: 'cherry', radius: 18, scoreOnMerge: 0, sfxBucket: 'small' as const },
  { name: 'strawberry', radius: 22, scoreOnMerge: 5, sfxBucket: 'small' as const },
  { name: 'grape', radius: 26, scoreOnMerge: 10, sfxBucket: 'small' as const },
  { name: 'orange', radius: 30, scoreOnMerge: 25, sfxBucket: 'medium' as const },
  { name: 'apple', radius: 36, scoreOnMerge: 50, sfxBucket: 'medium' as const },
  { name: 'pear', radius: 42, scoreOnMerge: 100, sfxBucket: 'medium' as const },
  { name: 'pineapple', radius: 48, scoreOnMerge: 250, sfxBucket: 'large' as const },
  { name: 'melon', radius: 54, scoreOnMerge: 500, sfxBucket: 'large' as const },
  { name: 'watermelon', radius: 62, scoreOnMerge: 1000, sfxBucket: 'large' as const },
] as const;

export type FruitTier = (typeof FRUIT_TIERS)[number];
export const MAX_TIER = FRUIT_TIERS.length - 1;

export const PHYSICS = {
  gravity: 0.7,
  friction: 0.5,
  frictionAir: 0.04,
  restitution: 0.0,
  density: 0.001,
  sleepThreshold: 30,
};

export const SPAWN = {
  weights: [30, 25, 20, 15, 10] as const,
};

export const THROW = {
  initialVy: 20,
  jitterVx: 0,
  handLerpFactor: 0.3,
  handAnimMs: 300,
};

export const GAME_OVER = {
  dangerLineY: 0.15,
  graceMs: 2000,
};

export const HUD = {
  scorePulseMilestone: 1000,
  bounceSfxMaxPerSec: 4,
};

export const SNAPSHOT = {
  intervalMs: 2000,
  maxAgeMs: 30 * 60 * 1000,
};

export const COLORS = {
  dangerLineNormal: 0xe51e50,
  dangerLineWarning: 0xff3b30,
  dangerLineAlphaNormal: 0.4,
  dangerLineAlphaWarning: 0.8,
};

export const STORAGE_KEYS = {
  highScore: 'high-score',
  tutorialSeen: 'tutorial-seen',
  bestEverByTier: 'best-by-tier',
  snapshot: 'game-snapshot',
};
